var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tezhegn"},[_c('div',{staticClass:"peark"},[_vm._v(_vm._s(_vm.$t("login.features")))]),_c('iframe',{staticClass:"kkk",attrs:{"name":"topIframe","width":"100%","height":"1000px","src":_vm.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }